import axios from 'axios';
import Integrante from '../types/Integrante';

async function InsertarInteresados(integrantes: Integrante[], codigoAgente: string, idPlan: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_socio"

    let docTitular = '';

    const socios = integrantes.map((integrante) => {
        
        const { documento, apellido, nombres, fechaNacimiento, sexo, email, celular, tipo, pais, provincia, localidad, domicilio, cuil } = integrante;
        
        if (tipo === 'Titular') docTitular = documento;
        
        return {
            dni: documento,
            apellido: apellido,
            nombres: nombres,
            fchnac: fechaNacimiento,
            sexo: sexo === 'Masc.' ? 'M' : 'F',
            email: email,
            celular: celular,
            tipo_socio: tipo.toUpperCase(),
            pais: pais,
            provincia: provincia,
            localidad: localidad,
            domicilio: domicilio,
            doctitular: docTitular,
            agente: codigoAgente,
            idplan: idPlan,
            cuil: cuil
        };
    });
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "definitivo": "NO",
            "socios": socios
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarInteresados;